module.exports = __webpack_public_path__ + "img/45.ea143e22.webp";